export default {
  trackEvent: 'analytic/TRACK_EVENT',
  sendAnalyticsData: 'analytic/SEND_ANALYTICS_DATA',
  sendAnalyticsDataSuccess: 'analytic/SEND_ANALYTICS_DATA_SUCCESS',
  sendAnalyticsDataFailure: 'analytic/SEND_ANALYTICS_DATA_FAILURE',
};
